export const useOfferAsterisk = (
  cashbackCapDescription?: string,
  firstTierMinimumSpendString?: string,
  clientCommissionString?: string
) => {
  const isOfferWithCapOrMinSpend =
    (cashbackCapDescription ?? '').trim() !== '' ||
    (firstTierMinimumSpendString ?? '').trim() !== '';

  const showAsterisk = isOfferWithCapOrMinSpend;

  const asteriskText = showAsterisk ? '*' : '';
  const commissionString = clientCommissionString
    ? `${clientCommissionString}${asteriskText}`
    : '';

  return {
    commissionString,
    showAsterisk,
  };
};
